document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-ritual-section]')
  if (!section) return

  const track = section.querySelector('[data-products-track]')
  const bars = track ? Array.from(section.querySelectorAll('[data-indicator-bar]')) : []

  // Mobile carousel
  if (track) {
    const getStep = () => {
      const card = track.querySelector(':scope > [data-ritual-product]')
      if (!card) return track.clientWidth
      const styles = getComputedStyle(track)
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0
      return card.offsetWidth + gap
    }

    if (bars.length) {
      const updateIndicator = () => {
        const step = getStep()
        const index = step ? Math.round(track.scrollLeft / step) : 0
        bars.forEach((bar, i) => {
          bar.classList.toggle('bg-black-200', i === index)
          bar.classList.toggle('bg-black-12', i !== index)
        })
      }

      let ticking = false
      track.addEventListener('scroll', () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
          updateIndicator()
          ticking = false
        })
      })
    }
  }

  const label = section.querySelector('[data-ritual-label]')
  const body = section.querySelector('[data-ritual-body]')
  const headingLines = section.querySelectorAll('[data-ritual-line]')
  const cardsBlock = section.querySelector('[data-ritual-cards]')
  const productsIndicator = section.querySelector('[data-products-indicator]')
  const cardImages = cardsBlock?.querySelectorAll('[data-ritual-card-image]')

  const reveal = () => {
    if (label) {
      gsap.to(label, {
        autoAlpha: 1,
        duration: 1.2,
        ease: 'power2.out',
      })
    }

    if (headingLines.length) {
      gsap.to(headingLines, {
        yPercent: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.12,
        delay: label ? 0.2 : 0,
      })
    }

    if (body) {
      gsap.to(body, {
        autoAlpha: 1,
        duration: 1.2,
        ease: 'power2.out',
        delay: label ? 0.45 : 0.15,
      })
    }

    if (cardsBlock) {
      const cardsDelay = body ? 0.55 : label ? 0.4 : 0.15

      gsap.to(cardsBlock, {
        y: 0,
        autoAlpha: 1,
        duration: 1.3,
        ease: 'power3.out',
        delay: cardsDelay,
      })

      if (cardImages?.length) {
        gsap.to(cardImages, {
          scale: 1,
          duration: 1.3,
          ease: 'power3.out',
          delay: cardsDelay,
          transformOrigin: 'center center',
        })
      }
    }

    if (productsIndicator) {
      gsap.to(productsIndicator, {
        y: 0,
        autoAlpha: 1,
        duration: 1.3,
        ease: 'power3.out',
        delay: body ? 0.55 : label ? 0.4 : 0.15,
      })
    }
  }

  // On load animation
  const buildEntrance = () => {
    if (label) gsap.set(label, { autoAlpha: 0 })
    if (body) gsap.set(body, { autoAlpha: 0 })

    if (headingLines.length) {
      gsap.set(headingLines, { yPercent: 120, opacity: 0 })
    }

    if (cardsBlock) {
      gsap.set(cardsBlock, { y: 40, autoAlpha: 0 })
      if (cardImages?.length) gsap.set(cardImages, { scale: 1.08, transformOrigin: 'center center' })
    }

    if (productsIndicator) {
      gsap.set(productsIndicator, { y: 40, autoAlpha: 0 })
    }
  }

  buildEntrance()

  if (window.ScrollTrigger) {
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top 75%',
      onEnter: reveal,
    })
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      onLeaveBack: buildEntrance,
    })

    section.querySelectorAll('[data-ritual-card-parallax]').forEach((el) => {
      const wrap = el.parentElement
      gsap.set(el, { scale: 1.25 })
      gsap.fromTo(
        el,
        { yPercent: 8 },
        {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      )
    })
  } else {
    reveal()
  }
})
